/**
 * Audit-log category — mirrors the API's AuditLogCategory enum. The API registers no string-enum
 * converter, so responses carry the underlying integer value; this is a numeric enum to match.
 */
export enum AuditLogCategory {
	Unknown = 0,
	TagChanges = 1,
	ContactMutation = 2,
}

/**
 * Category values the audit-log filter sends as the `category` query param. The API binds enum
 * query-string input by name (not number), so the filter passes the enum *name*. 'Unknown' is
 * intentionally excluded — it is a server-side catch-all, not a user-facing filter.
 */
export type AuditLogCategoryFilter = 'TagChanges' | 'ContactMutation';

export interface IAuditLogActor {
	name: string;
	userId: string;
	isLevitateSupport: boolean;
	byUser: boolean;
}

export interface IAuditLogResource {
	type: string;
	id: string;
}

export interface IAuditLogEntry {
	id: string;
	/** ISO timestamp (UTC) of the event. */
	timestamp: string;
	/** Pre-formatted, timezone-aware display string from the API. */
	timestampDisplay: string;
	eventType: string;
	category: AuditLogCategory;
	actor: IAuditLogActor;
	resource: IAuditLogResource;
	/** Arbitrary structured detail (added/removed tags, changed fields, etc.). */
	details: Record<string, unknown>;
	/** Human-readable one-line summary. */
	summary: string;
}

export interface IAuditLogFilters {
	contactId?: string;
	category?: AuditLogCategoryFilter;
	lookbackDays: number;
	/** ISO-8601 UTC instant. When both startDate and endDate are set, the custom range is sent and lookbackDays is ignored. */
	startDate?: string;
	endDate?: string;
}
